import booleanLiteral from '../../../../constants/functions/booleanLiteral';
import dataType from '../../../../constants/dataType';
import ReportingRegime from '../../../../types/common/ReportingRegime';

const timeInitialValue: string = '00:00:00';

const get = (type: string, regime?: string): string => {


    switch (type) {
        case dataType.integer:
        case dataType.decimal:
        case dataType.unixTime:
            return '0';

        case dataType.boolean:
            return booleanLiteral.true;

        case dataType.date:
            return new Date().toISOString().substring(0, 10);

        case dataType.time:
            return timeInitialValue;

        case dataType.dateTime:
            return resolveDateTime(regime);
    }

    return '';
}

const resolveDateTime = (regime?: string) => {
    if (regime === ReportingRegime.SixSecurities) {
        return new Date().toISOString().substring(0, 11) + timeInitialValue + '.00000Z';
    }

    if (regime === ReportingRegime.MifirTransparency) {
        return new Date().toISOString().substring(0, 11) + timeInitialValue + '.000000Z';
    }

    if (regime === ReportingRegime.Cat) {
        return new Date().toISOString().substring(0, 11) + timeInitialValue + '.0000000Z';
    }

    if (regime === ReportingRegime.Remit) {
        return new Date().toISOString().substring(0, 11) + timeInitialValue + '.000000Z';
    }

    return new Date().toISOString().substring(0, 11) + timeInitialValue + 'Z';
}

const constantInitialValueHelper = {
    get
};

export default constantInitialValueHelper;
